/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function handleCollectionViewToggle() {
    const productViewButtons = document.querySelectorAll('.product-view__button');
    const collectionContainer = document.querySelector('.collection-products');

    productViewButtons.forEach(button => {
      button.addEventListener('click', function () {
        const view = this.getAttribute('data-view');
        const type = this.getAttribute('data-view-type');

        if (collectionContainer) {
          view && collectionContainer.setAttribute('data-view', view);
          type && collectionContainer.setAttribute('data-view-type', type);
        } else {
          console.warn('Collection container not found in the DOM');
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    try {
      const collectionContainer = document.querySelector('.collection-products');
      if (collectionContainer) {
        collectionContainer.setAttribute('data-view', 'row');
        collectionContainer.classList.add('initializing');
        
        window.addEventListener('load', function() {
          setTimeout(() => {
            collectionContainer.classList.remove('initializing');
          }, 500);
        });
      }
      handleCollectionViewToggle();
    } catch (err) {
      console.error("Error in handleCollectionViewToggle:", err);
    }
  });

  // Rebuy Cart Customization
  
  function initRebuyCart() {
    document.addEventListener("rebuy:smartcart.ready", (e) => {
      const cart = e.detail.smartcart.cart;
      showPaymentIcons();
      freeShippingLimit(cart);
    });
  
    document.addEventListener("rebuy:cart.change", (e) => {
      const cart = e.detail.cart.cart;
      showPaymentIcons();
      freeShippingLimit(cart);
    });
  }
  
  function showPaymentIcons() {
    setTimeout(() => {
      const paymentIcons = document.querySelector(".cart__drawer__payment__icons");
      const checkoutArea = document.querySelector('div[data-rebuy-component="checkout-area"]');
  
      if (!paymentIcons || !checkoutArea || checkoutArea.querySelector(".cloned-payment-icons")) {
        return;
      }
  
      const clonedPaymentIcons = paymentIcons.cloneNode(true);
      clonedPaymentIcons.classList.add("cloned-payment-icons"); 
      checkoutArea.appendChild(clonedPaymentIcons);
    }, 500);
  }

  function freeShippingLimit(cart) {
    const selectors = {
      finalAmount: ".rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-amount span:last-child",
      freeShippingLimit: ".cart__drawer__free-shipping-limit",
      checkoutArea: 'div[data-rebuy-component="cart-subtotal"]',
      shippingCost: ".cart__drawer__free-shipping-limit__amount",
      estimatedDelivery: ".cart__drawer__estimated__delivery",
    };
    const translations = {
      freeShipping: "FREE",
    }

    function calculate() {
      // Only get the final amount (what customer actually pays)
      const currentCartTotal = getRebuyHtmlPrice(selectors.finalAmount);
      
      const freeShippingLimit = window.theme.settings.freeShippingLimit; 
      const shippingCost = window.theme.settings.shippingCost; 
      
      let finalTotal = currentCartTotal; 
      let hasFreeShipping = false;
    
      
    
      if (currentCartTotal >= freeShippingLimit) {
        hasFreeShipping = true;
      } else {
        hasFreeShipping = false;
        finalTotal = currentCartTotal + shippingCost;
      }

    
      return { 
        total: finalTotal, 
        shippingCost, 
        hasFreeShipping 
      };
    }

    function formatPrice(price) {
      return price.toLocaleString('da-DK', { style: 'currency', currency: cart.currency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function getRebuyHtmlPrice(selector) {
      const element = document.querySelector(selector);
      
      if (!element) {
        return null;
      }
    
      const value = element.textContent?.trim();
    
      if (!value) {
        return null;
      }
    
      // Use regex to extract just the price part after "kr"
      // Match "kr" followed by whitespace, then capture the price pattern
      const priceMatch = value.match(/kr\s+([\d.,]+)/);
      
      if (!priceMatch) {
        return null;
      }
      
      const priceString = priceMatch[1]; // Gets "390,00" or "1.300,00"
    
      // Handle Danish number format:
      // "390,00" -> 390.00
      // "1.300,00" -> 1300.00 (dot is thousands separator, comma is decimal)
      let price = priceString;
      
      if (price.includes('.') && price.includes(',')) {
        // Format like "1.300,00" - dot is thousands, comma is decimal
        price = price.replace(/\./g, '').replace(',', '.');
      } else if (price.includes(',')) {
        // Format like "390,00" - comma is decimal separator
        price = price.replace(',', '.');
      }
    
      
      const parsedPrice = parseFloat(price);
      
      return isNaN(parsedPrice) ? null : parsedPrice;
    }

    function setInnerText(selector, value) {
      const el = document.querySelector(selector);

      if(el) {
        el.innerText = value;
      }
    }

    function addOrUpdateShipping(shippingCost, hasFreeShipping) {
      const checkoutArea = document.querySelector(selectors.checkoutArea);
      const freeShippingLimitEl = document.querySelector(selectors.freeShippingLimit);
      const estimatedDeliveryEl = document.querySelector(selectors.estimatedDelivery);
    
      if (!checkoutArea || !freeShippingLimitEl) {
        return;
      }
    
      const existingShippingCostEl = checkoutArea.querySelector(selectors.shippingCost);
    
      if (existingShippingCostEl) {
        existingShippingCostEl.innerText = hasFreeShipping ? translations.freeShipping : formatPrice(shippingCost);
        return;
      }
    
      const newShippingCostEl = freeShippingLimitEl.querySelector(selectors.shippingCost);
      newShippingCostEl.innerText = hasFreeShipping ? translations.freeShipping : formatPrice(shippingCost);
    
      const clonedFreeShippingLimit = freeShippingLimitEl.cloneNode(true);
      checkoutArea.appendChild(clonedFreeShippingLimit);
    
      if (estimatedDeliveryEl) {
        const clonedEstimatedDelivery = estimatedDeliveryEl.cloneNode(true);
        checkoutArea.appendChild(clonedEstimatedDelivery);
      }
    }

    setTimeout(() => {
      const { total, shippingCost, hasFreeShipping } = calculate();

  
  
  addOrUpdateShipping(shippingCost, hasFreeShipping);
    });
  }  
  
  initRebuyCart();

  function registerInfiniteScrollLoadMoreButton() {
    const selectors = {
      loadMoreButton: ".js-load-more",
      totalPages: "[data-total-pages]",
      currentPage: "[data-current-page]",
      nextUrl: "[data-next-url]",
      loadMoreText: "[load-more-text]",
      loaderText: "[loader-text]",
      products:
        ".collection__products .grid-item.product-item:not(.product-grid-item-placeholder)",
      productGrid: "div[data-products-grid] .grid",
      currentProducts: ".current-products",
      totalProducts: ".total-products",
      nextCollection: "#NextCollection",
    };

    const hideClass = "hide";
    const loadMoreButton = document.querySelector(selectors.loadMoreButton);
    const nextCollection = document.querySelector(selectors.nextCollection);
    const currentProducts = document.querySelector(selectors.currentProducts);
    const totalProducts = document.querySelector(selectors.totalProducts);
    const totalPages = document.querySelector(selectors.totalPages);

    if (
      !loadMoreButton ||
      (totalProducts &&
        currentProducts &&
        currentProducts.textContent === totalProducts.textContent)
    ) {
      if (nextCollection) {
      }
      return;
    }

    loadMoreButton.addEventListener("click", (e) => {
      const totalPagesValue = Number(totalPages.value);
      let currentPage = document.querySelector(selectors.currentPage);
      let currentPageValue = parseInt(currentPage.value);
      let nextUrl = document.querySelector(selectors.nextUrl);

      loadMoreButton.setAttribute("disabled", true);

      const loadMoreText = loadMoreButton.querySelector(selectors.loadMoreText);
      const loaderText = loadMoreButton.querySelector(selectors.loaderText);

      loadMoreText.classList.add(hideClass);
      loaderText.classList.remove(hideClass);

      fetch(nextUrl.value)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const products = doc.querySelectorAll(selectors.products);
          insertProducts(products);

          const newUrl = nextUrl.value;

          nextUrl.value = nextUrl.value.replace(
            `page=${currentPageValue + 1}`,
            `page=${currentPageValue + 2}`
          );
          currentPage.value = currentPageValue + 1;

          if (currentPage.value >= totalPagesValue) {
            loadMoreButton.classList.add(hideClass);

            if (currentProducts && totalProducts) {
              currentProducts.innerHTML = totalProducts.innerHTML;
            }
          }

          loadMoreButton.removeAttribute("disabled");
          loadMoreText.classList.remove(hideClass);
          loaderText.classList.add(hideClass);

          window.history.pushState(
            {
              param: Shopify.queryParams,
            },
            document.title,
            newUrl
          );
        })
        .catch((error) => {
          console.warn("Loading more products failed", error);
          loadMoreButton.classList.add(hideClass);
        });
    });
  }

  function insertProducts(products, before = false) {
    const selectors = {
      productGrid: "div[data-products-grid] .grid",
      currentProducts: ".current-products",
      productCard: ".grid-item.product-item:not(.product-grid-item-placeholder)",
    };

    const productGrid = document.querySelector(selectors.productGrid);

    products.forEach((product) => {
      if (before) {
        productGrid.prepend(product);
      } else {
        productGrid.appendChild(product);
      }
    });

    const currentProducts = document.querySelector(selectors.currentProducts);
    currentProducts.innerHTML = productGrid.querySelectorAll(selectors.productCard).length;
  }

  registerInfiniteScrollLoadMoreButton();


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
